import { render, staticRenderFns } from "./register-step1.vue?vue&type=template&id=7809c65c&scoped=true"
import script from "./register-step1.vue?vue&type=script&lang=js"
export * from "./register-step1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7809c65c",
  null
  
)

export default component.exports